import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({});
class ExpertQuestionTemplateSection extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    let Label = (
      <TableRow>
        {" "}
        <TableCell>
          {
            <span style={{ fontWeight: "500" }}>
              <Trans i18nKey="global_label" />:{" "}
            </span>
          }
          {this.props.data.label}
        </TableCell>
        <TableCell>
          {
            <span style={{ fontWeight: "500" }}>
              <Trans i18nKey="global_type" />:{" "}
            </span>
          }
          {this.props.data.type}
        </TableCell>
        {(this.props.data.type === "Radio" ||
          this.props.data.type === "Select") && (
          <TableCell>
            {
              <span style={{ fontWeight: "500" }}>
                <Trans i18nKey="global_values" />:{" "}
              </span>
            }
            {this.props.data.values}
          </TableCell>
        )}
        {(this.props.data.type === "TextInput" ||
          this.props.data.type === "TextArea") && (
          <TableCell>
            {
              <span style={{ fontWeight: "500" }}>
                <Trans i18nKey="default_text" />:{" "}
              </span>
            }
            {this.props.data.default}
          </TableCell>
        )}
        <TableCell>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <Tooltip
                title={this.props.t("expert_question_section_delete_tooltip")}
              >
                <IconButton
                  size="small"
                  onClick={() => this.props.deleteSection(this.props.data)}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div>
              <Tooltip
                title={this.props.t("expert_question_section_edit_tooltip")}
              >
                <IconButton
                  size="small"
                  onClick={() =>
                    this.props.openCreateSectionEdit(this.props.data)
                  }
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            </div>
            {(this.props.data.type === "Radio" ||
              this.props.data.type === "Select" ||
              this.props.data.type === "Checkbox") && (
              <Tooltip
                title={this.props.t(
                  "expert_question_section_add_child_tooltip"
                )}
              >
                <IconButton
                  size="small"
                  onClick={() => this.props.openCreateSection(this.props.data)}
                  aria-label="Add child section"
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </TableCell>
      </TableRow>
    );
    const { classes, t } = this.props;
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>{Label}</div>
    );
  }
}
export default withTranslation()(
  withStyles(styles)(ExpertQuestionTemplateSection)
);
